import { selectCurrencyById } from '@store/CurrencyReducer'
import { useAppSelector } from '@store/hooks'
import { selectSelectedMembershipProfileCurrency } from '@store/membership/MembershipProfileCurrencyReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedMembershipProfileCurrency())
  const currency = useAppSelector(selectCurrencyById(item?.currency!))

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        title={'Are you sure ?'}
        subTitle={`This will permanently delete this balance and the member's remaining amount of ${item.amount}${currency ? ` ${currency.symbol}` : ''}. This action is immediate and cannot be undone.`}
      />
      <Form.Item name="id" hidden required rules={[]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
